<template>
	<div class="sub_contents brand_detail" :class="{ 'popup-mode': isPopup }">
		<!-- 브랜드 상단 메뉴 - 팝업 모드이거나 hideListButton이 true일 때 숨김 -->
		<div v-if="!isPopup && !hideListButton" class="brand_top_menu">
			<div class="cont_center">
				<ul class="brand_menu_list">
					<li>
						<a href="#" @click.prevent="navigateToBrandList(0)">
							전체
						</a>
					</li>
					<li>
						<a href="#" @click.prevent="navigateToBrandList(1)">
							<img src="@/assets/images/brand/icon_category_1_off.jpg" alt="" />
							쇼핑·생활
						</a>
					</li>
					<li>
						<a href="#" @click.prevent="navigateToBrandList(2)">
							<img src="@/assets/images/brand/icon_category_2_off.jpg" alt="" />
							외식·레스토랑
						</a>
					</li>
					<li>
						<a href="#" @click.prevent="navigateToBrandList(3)">
							<img src="@/assets/images/brand/icon_category_3_off.jpg" alt="" />
							커피·제빵
						</a>
					</li>
					<li>
						<a href="#" @click.prevent="navigateToBrandList(4)">
							<img src="@/assets/images/brand/icon_category_4_off.jpg" alt="" />
							패션·뷰티
						</a>
					</li>
					<li>
						<a href="#" @click.prevent="navigateToBrandList(5)">
							<img src="@/assets/images/brand/icon_category_5_off.jpg" alt="" />
							도서·교육
						</a>
					</li>
					<li>
						<a href="#" @click.prevent="navigateToBrandList(6)">
							<img src="@/assets/images/brand/icon_category_6_off.jpg" alt="" />
							문화·헬스
						</a>
					</li>
					<li>
						<a href="#" @click.prevent="navigateToBrandList(7)">
							<img src="@/assets/images/brand/icon_category_7_off.jpg" alt="" />
							여행·숙박·교통
						</a>
					</li>
					<li>
						<a href="#" @click.prevent="navigateToBrandList(8)">
							<img src="@/assets/images/brand/icon_category_8_off.jpg" alt="" />
							유아·체험
						</a>
					</li>
				</ul>
			</div>
		</div>

		<div class="cont_center">
			<div class="brand_view_area">
				<p class="brand_view_logo">
					<img :src="makeBrandImageUrl(brandDetail.brandPath)" alt="" />
					<!-- 온라인 브랜드일 경우에만 ONLINE 표시 추가 -->
					<span v-if="brandDetail.brandType === 'BRAND_ONLINE'" class="online">online</span>
				</p>

				<div class="brand_detail_area">
					<div class="brand_top_area">
						<h1 v-if="brandDetail.brandName" class="title_brand">
							{{ brandDetail.brandName }}
						</h1>

						<p class="brand_descript" v-html="brandDetail.brandRmks"></p>
					</div>
					<BrandSeoSummary :brand="brandDetail" :cards="cardItems" />

					<div class="detail_info_area">
						<div class="target_card_area" :class="{ 'is-modal-layout': isModal }">
							<div class="card_header">
								<h4 class="title_target_card">대상카드</h4>
								<!-- 모바일 모달에서만: '대상카드' 우측에 안내사항 표시 -->
								<button v-if="isModal && isViewportMobile" type="button"
									class="btn_card_notice btn_notice_unified" @click="showNotice = true">
									안내사항
								</button>
								<!-- 안내사항 버튼을 여기로 이동 -->
								<button v-if="!isModal" type="button" class="btn_mobile_notice btn_notice_unified"
									@click="showNotice = true">
									안내사항
								</button>
							</div>
							<div class="card_list_area"
								:style="isModal ? 'height:auto !important; max-height:none !important; overflow:visible !important; white-space:normal !important; padding:0 10px !important;' : ''">
								<!-- 속성명을 소문자로 수정 -->
								<!-- 모달일 때는 행 단위로 끊어서 렌더링(명시적 줄바꿈) -->
								<div v-if="isModal" class="card-icons-modal"
									:class="{ 'single-mode': isIndividualCardDomain && cardItems.length === 1 }"
									style="display:flex; flex-direction:column; gap:6px; align-items:flex-start; width:100%;">
									<div v-for="(row, rowIndex) in cardRows" :key="rowIndex"
										style="display:flex; gap:10px; align-items:center; width:100%; flex-wrap:nowrap;">
										<img v-for="item in row" :key="item.key" :src="getCardImageUrl(item.code)"
											:alt="item.alt" class="modal-card-icon" :class="item.class"
											:style="getModalCardStyle(item)" />
									</div>
									<span v-if="isAllCardStatusN" class="card-label is-hivitamin-target">
										<span class="hivitamin-word">하이비타민</span> 고객 대상
									</span>
									<span v-else class="card-label">{{ brandDetail.cardName }}</span>
								</div>

								<!-- 일반 화면은 기존 방식(한 줄/자동 줄바꿈은 CSS에 맡김) -->
								<div v-else class="card-icons"
									:class="{ 'single-card-mode': isIndividualCardDomain && cardItems.length === 1 }">
									<img v-for="item in cardItems" :key="item.key" :src="getCardImageUrl(item.code)"
										:alt="item.alt" :class="item.class" />
									<span v-if="isAllCardStatusN" class="card-label is-hivitamin-target">
										<span class="hivitamin-word">하이비타민</span> 고객 대상
									</span>
									<span v-else class="card-label">{{ brandDetail.cardName }}</span>
								</div>
							</div>
						</div>
						<div class="bill_discount" :class="{ 'special-discount': isAllCardStatusN }">
							<template v-if="isAllCardStatusN">
								<p class="special_discount_text">
									<span>특별</span>
									<span>할인</span>
								</p>
							</template>
							<template v-else>
								<p class="title_bill">청구할인</p>
								<p class="discount_percent"><strong>{{ brandDetail.benefit }}</strong>%</p>
							</template>
						</div>

						<ul class="brand_info_list">
							<li class="call">{{ brandDetail.phone }}</li>
							<li class="homepage">
								<!-- 홈페이지 URL 링크 수정 -->
								<a v-if="brandDetail.homepageUrl" href="javascript:void(0)"
									@click="openHomepage(brandDetail.homepageUrl)" class="homepage-link">
									{{ brandDetail.homepageUrl }}
								</a>
								<span v-else class="no-homepage">홈페이지 정보 없음</span>
							</li>
							<!-- 모달에서만 표시되는 안내사항 버튼 -->
							<li v-if="isModal" class="notice modal-notice">
								<button type="button" class="btn_notice_unified" @click="showNotice = true">
									안내사항
								</button>
							</li>
							<!-- PC에서만 표시되는 안내사항 버튼 -->
							<li v-if="!isModal" class="notice mobile-hidden">
								<button type="button" class="btn_notice_unified" @click="showNotice = true">
									안내사항
								</button>
							</li>
						</ul>
					</div>
				</div>
			</div>

			<!-- 브랜드 타입이 온라인이 아닌 경우에만 매장 찾기 버튼 표시 -->
			<div class="btn_shop_area" v-if="brandDetail.brandType !== 'BRAND_ONLINE'">
				<button @click="openShopSearchPopup" class="btn_type2">매장 찾기</button>
			</div>

			<div class="brand_view_img" v-html="safeBrandDetailView"></div>

			<!-- 목록보기 버튼 - 팝업 모드이거나 hideListButton이 true일 때 숨김 -->
			<div v-if="!isPopup && !hideListButton" class="btn_write_area">
				<button @click="goBackToList" class="btn_list">목록 보기</button>
			</div>
		</div>
	</div>

	<!-- 팝업을 컴포넌트 최상위로 이동 -->
	<div class="notice_pop_area_fixed" v-if="showNotice">
		<div class="notice_pop">
			<button type="button" class="close_notice_info" @click="showNotice = false">
				안내사항 닫기
			</button>

			<p class="title_noti">안내사항</p>

			<!-- <strong>대상카드</strong> -->

			<p class="card_txt">
				{{ brandDetail.benefitCard }}
			</p>

			<ol class="card_info_list" v-if="brandDetail.brandType === 'BRAND_OFFLINE'">
				<!-- 오프라인 브랜드일 때 기존 내용 표시 -->
				<li>
					<span>01</span>
					백화점, 할인점 입점매장 및 일부가맹점은 <br />혜택에서 제외될 수 있습니다.
				</li>
				<li>
					<span>02</span>
					가맹점별 카드사 가입 기준이 달라 매장찾기를 통하여,
					<br />혜택 적용 가맹점 및 제외 카드사를 꼭 확인해주세요.
				</li>
			</ol>

			<ol class="card_info_list" v-else>
				<!-- 온라인 브랜드나 기타 브랜드일 때 새로운 내용 표시 -->
				<li>
					<span>01</span>
					간편결제앱을 통한 결제는 할인 적용이 되지 않을 수 있습니다.
				</li>
			</ol>
		</div>
	</div>

	<!-- 매장찾기 팝업 -->
	<div class="layer_bg" v-if="searchShop">
		<div class="layer_popup search_shop">
			<button class="btn_close" @click="resetAndCloseShopSearchPopup">X</button>

			<h2 class="title_search_shop">매장찾기 <span>({{ total || 0 }})</span></h2>

			<div class="content">
				<div class="search_shop_area">
					<div class="search_shop_input">
						<h3 class="title_search_shop2">브랜드검색</h3>

						<input type="text" class="search2" :value="brandDetail.brandName || '-'" disabled />
					</div>

					<div class="search_shop_input" v-if="false">
						<h3 class="title_search_shop2">지역검색</h3>

						<select v-model="storeSearchParams.sido" @change="onRegionChange" class="region-select"
							:disabled="isLoading.regions">
							<option value="">시/도 선택</option>
							<option v-for="region in regions" :key="region" :value="region">{{ region }}</option>
						</select>

						<select v-model="storeSearchParams.gugun" class="subregion-select"
							:disabled="isLoading.subRegions || !storeSearchParams.sido">
							<option value="">시/구/군</option>
							<option v-for="subRegion in subRegions" :key="subRegion" :value="subRegion">{{ subRegion }}
							</option>
						</select>
					</div>

					<div class="search_shop_input">
						<h3 class="title_search_shop2">명칭검색</h3>

						<input type="text" class="search2" placeholder="매장명" v-model="storeSearchParams.name"
							@keyup.enter="searchStores" />

						<div class="btn_search">
							<button type="button" @click="searchStores">검색</button>
						</div>
					</div>
				</div>

				<!-- 검색 결과 -->
				<div class="search_shop_result">
					<ul class="shop_result_list">
						<li v-for="(store, index) in storeList" :key="store.storeUuid">
							<div class="shop_info_area" :class="{ open: selectedStoreIndex === index }"
								@click="toggleStoreMap(index)">
								<div class="shop_info_txt">
									<h4 class="title_shop_name">{{ store.storeName }}</h4>
									<p class="address_shop_name">{{ store.address }}</p>
								</div>

								<p class="discout_percent">{{ store.benefit || '할인혜택 없음' }}</p>
								<p class="shop_call">{{ store.phone || '-' }}</p>
							</div> <!-- 지도영역 -->
							<div v-if="selectedStoreIndex === index" class="shop_map_area"
								style="min-height:300px; width:100%; display:block;">
								<NaverMapMo :lat="store.latitude" :lng="store.longitude" :title="store.storeName"
									:address="store.address" :is-ready="mapReadyMap[index] === true"
									@map-loaded="onMapLoaded(index)" @map-error="handleMapError(index)" />
								<div v-if="!mapLoadedMap[index]" class="map-loading">
									지도를 불러오는 중...
								</div>
							</div>
							<!-- //지도영역 -->
						</li>
					</ul>

					<!-- 데이터가 없을 경우 -->
					<div v-if="storeList.length === 0 && isSearched" class="no-data">
						검색 결과가 없습니다.
					</div>
				</div>
				<!-- //검색 결과 -->

				<!-- 페이징 -->
				<div class="paging_area2" v-if="storeList.length > 0">
					<button type="button" class="prev" @click="onPageChange(currentPage - 1)"
						:disabled="currentPage === 1">이전</button>

					<div class="paging_num">
						<button v-for="page in displayedPages" :key="page" type="button"
							:class="{ active: page === currentPage }" @click="onPageChange(page)">
							{{ page }}
						</button>
					</div>

					<button type="button" class="next" @click="onPageChange(currentPage + 1)"
						:disabled="currentPage >= totalPages">다음</button>
				</div>
				<!-- 페이징 -->
			</div>
		</div>
	</div>
</template>

<script>
import { ref, watch, computed, onMounted } from "vue";
import { useQuery } from "@tanstack/vue-query";
import { getAxios } from "@/lib/AxiosCall";
import { DEFAULT_NO_IMAGE } from "@/lib/Constant";
import { useRouter, useRoute, onBeforeRouteLeave } from "vue-router";
import NaverMap from "@/components/NaverMap.vue";
import NaverMapMo from "@/components/NaverMapMo.vue";
import { getConfig } from "@/lib/Config";
import { setPageMeta, setNotFoundMeta, currentProfile } from "@/lib/Seo";
import { setBrandJsonLd } from "@/lib/brandSeo";

export default {
	components: {
		NaverMapMo,
	},
	props: {
		brandUuid: {
			type: String,
			default: ''
		},
		isPopup: {
			type: Boolean,
			default: false
		},
		hideListButton: {
			type: Boolean,
			default: false
		},
		isModal: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			brandLogoSrc: require("@/assets/images/brand/brand_view_logo.png"),
			popupShop: false,
			showNotice: false,
			searchShop: false,

			// 매장 검색 관련
			selectedStoreIndex: -1,
			storeSearchParams: {
				sido: "", // region에서 sido로 변경
				gugun: "", // subRegion에서 gugun으로 변경
				name: "", // keyword에서 name으로 변경
				//branchUuid: getBranchUuid() || "", // sessionStorage 대신 함수 호출로 변경
				brandUuid: sessionStorage.getItem("brandUuid") || "" // 브랜드 UUID 추가
			},
			regions: [], // 하드코딩된 리스트 대신 API에서 받아올 빈 배열로 변경
			subRegions: [],
			mapLoadedMap: {}, // 각 지도별 로딩 상태 관리
			mapReadyMap: {}, // 각 지도별 렌더링 준비 상태 관리
			isLoading: {
				regions: false,
				subRegions: false,
				search: false
			}
		};
	},
	setup(props) {
		console.log('BI_002 setup - isPopup:', props.isPopup, 'hideListButton:', props.hideListButton);

		// Nike 매장 정렬 순서 (HFO_MS_001과 동일)
		const nikeStoreOrder = [
			'나이키 홍대', '나이키 두타', '나이키 압구정',
			'나이키 아이파크몰용산', '나이키 롯데몰은평', '나이키 고잔',
			'나이키 AK플라자세종', '나이키 서산', '나이키 대구호림',
			'나이키 연제', '나이키 경성부경', '나이키 양산뉴타운'
		];

		// 기존 모바일 감지 로직
		const windowWidth = ref(window.innerWidth);
		const isIndividualCardDomain = ref(false);
		const baseMobile = computed(() => windowWidth.value < 768);
		// 실제 뷰포트 기준 모바일(팝업/강제 모바일 모드와 분리)
		const isViewportMobile = computed(() => windowWidth.value <= 1023);

		// 팝업 모드일 때는 항상 모바일로 처리 - 강화된 감지 로직
		const isMobile = computed(() => {
			// 1. props로 전달된 isPopup 체크
			if (props.isPopup) {
				console.log('isMobile: true (props.isPopup)');
				return true;
			}

			// 2. 부모 컨테이너가 팝업인지 체크 (DOM 기반)
			if (typeof window !== 'undefined') {
				const popupContainer = document.querySelector('.brand_popup_container');
				if (popupContainer) {
					console.log('isMobile: true (popup container detected)');
					return true;
				}
			}

			// 3. 기본 모바일 화면 크기 체크
			const result = baseMobile.value;
			console.log('isMobile computed:', result, 'windowWidth:', windowWidth.value);
			return result;
		});

		// 윈도우 리사이즈 이벤트 처리
		const handleResize = () => {
			windowWidth.value = window.innerWidth;
		};

		onMounted(() => {
			window.addEventListener('resize', handleResize);
			console.log('BI_002 mounted - isPopup:', props.isPopup, 'isMobile:', isMobile.value);
			try {
				const origin = window.location.origin;
				// bridgem.hivitamin.co.kr을 제외한 모든 도메인은 개별 카드 도메인으로 처리
				isIndividualCardDomain.value = origin !== 'https://bridgem.hivitamin.co.kr';
			} catch (e) {
				console.warn('isIndividualCardDomain detection failed', e);
			}
		});

		// 기존 setup 코드들...
		const route = useRoute();
		// prefer route param, then sessionStorage, then prop
		const brandUuid = ref(route.params.brandUuid || sessionStorage.getItem("brandUuid") || props.brandUuid || "");

		const currentPage = ref(1);
		const pageSize = ref(10);
		const total = ref(0);
		const isSearched = ref(false);
		const brandDetail = ref([]);

		const cardItems = computed(() => {
			const items = [];
			const d = brandDetail.value || {};

			// [테스트용] KB카드 강제 표시 로직 (테스트 후 삭제 또는 주석 처리 필요)
			// .env 또는 코드 상에서 강제 활성화
			const isTestMode = process.env.VUE_APP_TEST_DOMAIN || false;
			if (isTestMode) {
				// VUE_APP_TEST_DOMAIN 값에 따라 테스트할 카드 분기
				if (isTestMode.includes('nh') || isTestMode.includes('NH')) {
					return [{ key: 'nh', code: 'nh', alt: '농협카드', class: 'card-icon-large nh-card' }];
				}
				// 기본값은 KB카드
				return [{ key: 'kb', code: 'kb', alt: '국민카드', class: 'card-icon-large kb-card' }];
			}

			if (d.hanaYn === 'Y') items.push({ key: 'hana', code: 'hana', alt: '하나카드', class: 'card-icon' });
			if (d.bcYn === 'Y') items.push({ key: 'bc', code: 'bc', alt: '비씨카드', class: 'card-icon' });
			if (d.shYn === 'Y') items.push({ key: 'sh', code: 'sh', alt: '신한카드', class: 'card-icon' });
			if (d.kbYn === 'Y') items.push({ key: 'kb', code: 'kb', alt: '국민카드', class: 'card-icon-large kb-card' });
			if (d.nhYn === 'Y') items.push({ key: 'nh', code: 'nh', alt: '농협카드', class: 'card-icon-large nh-card' });
			if (d.lotteYn === 'Y') items.push({ key: 'lotte', code: 'lotte', alt: '롯데카드', class: 'card-icon' });
			if (d.smYn === 'Y') items.push({ key: 'sm', code: 'sm', alt: '삼성카드', class: 'card-icon' });
			if (d.hdYn === 'Y') items.push({ key: 'hd', code: 'hd', alt: '현대카드', class: 'card-icon' });
			if (d.weYn === 'Y') items.push({ key: 'woori', code: 'woori', alt: '우리카드', class: 'card-icon' });
			return items;
		});

		const cardRows = computed(() => {
			const rows = [];
			const items = cardItems.value;
			const chunkSize = props.isModal && isViewportMobile.value ? 3 : 5;
			for (let i = 0; i < items.length; i += chunkSize) {
				rows.push(items.slice(i, i + chunkSize));
			}
			return rows;
		});

		const getModalCardStyle = (item) => {
			// 모바일 모달에서는 아이콘을 더 크게
			const isMobileModal = props.isModal && isViewportMobile.value;

			// 1. 단일 카드가 1개만 있고 개별 카드 도메인일 경우 사이즈 조정 (30% 축소)
			if (isIndividualCardDomain.value && cardItems.value.length === 1) {
				const key = cardItems.value[0].key;

				// KB카드 (4:1 비율)
				if (key === 'kb') {
					return {
						width: isMobileModal ? '90px' : '162px',
						height: isMobileModal ? '22px' : '41px',
						objectFit: 'contain',
						objectPosition: 'left center',
						borderRadius: '4px',
						flex: '0 0 auto',
						flexShrink: 0,
					};
				}

				// NH카드 (3:1 비율)
				if (key === 'nh') {
					return {
						width: isMobileModal ? '67px' : '122px',
						height: isMobileModal ? '22px' : '41px',
						objectFit: 'contain',
						objectPosition: 'left center',
						borderRadius: '4px',
						flex: '0 0 auto',
						flexShrink: 0,
					};
				}

				// 그 외 단일 카드
				return {
					width: isMobileModal ? '49px' : '74px',
					height: isMobileModal ? '29px' : '44px',
					objectFit: 'contain',
					borderRadius: '4px',
					flex: '0 0 auto',
					flexShrink: 0,
				};
			}

			// 2. 그 외 기본 사이즈 (여러 카드일 때) + KB/NH 예외 처리
			const key = item ? item.key : '';
			if (key === 'kb') {
				// KB카드 List Mode
				// PC: 다른 카드(40px)과 높이 맞춤 (Width 160)
				return {
					width: isMobileModal ? '128px' : '160px',
					height: isMobileModal ? '32px' : '40px',
					objectFit: 'contain',
					objectPosition: 'left center',
					borderRadius: '4px',
					flex: '0 0 auto',
					flexShrink: 0,
				};
			}
			if (key === 'nh') {
				// NH카드 List Mode
				// PC: 다른 카드(40px)과 높이 맞춤 (Width 120)
				return {
					width: isMobileModal ? '96px' : '120px',
					height: isMobileModal ? '32px' : '40px',
					objectFit: 'contain',
					objectPosition: 'left center',
					borderRadius: '4px',
					flex: '0 0 auto',
					flexShrink: 0,
				};
			}

			// 일반 카드
			return {
				width: isMobileModal ? '70px' : '60px',
				height: isMobileModal ? '42px' : '40px',
				objectFit: 'contain',
				borderRadius: '4px',
				flex: '0 0 auto',
				flexShrink: 0,
			};
		};
		const storeList = ref([]); // storeList를 반응형으로 선언
		const nikeFullSortedList = ref([]); // Nike 매장 전체 정렬 목록 캐시
		const brandReqData = ref({
			page: currentPage.value,
			size: pageSize.value,
			brandUuid: brandUuid.value,
			//branchUuid: getBranchUuid(), // sessionStorage 대신 함수 호출로 변경
		});
		let brandDetailView = 12345;

		let popShopList = ref([]);
		const popShopReqData = ref({
			page: currentPage.value,
			size: pageSize.value,
			//branchUuid: getBranchUuid(), // sessionStorage 대신 함수 호출로 변경
		});

		const brandData = useQuery({
			queryKey: ["get-branch-brand", new Date().getTime(), brandReqData.value],
			queryFn: () => getAxios("/hvm/v1/branch/brand", brandReqData.value),
			enabled: true,
		});
		brandData.refetch();

		// react to route param changes (supports direct URL access)
		watch(
			() => route.params.brandUuid,
			(newVal) => {
				const newUuid = newVal || sessionStorage.getItem("brandUuid") || props.brandUuid || '';
				if (newUuid && newUuid !== brandUuid.value) {
					brandUuid.value = newUuid;
					brandReqData.value = { ...brandReqData.value, brandUuid: newUuid };
					try { brandData.refetch(); } catch (e) { console.warn('brandData.refetch error', e); }
					try { storeData.refetch(); } catch (e) { console.warn('storeData.refetch error', e); }
				}
			}
		);

		watch(
			() => brandData.data.value,
			(newData) => {
				if (newData && !newData?.page?.list?.[0]) setNotFoundMeta("브랜드");
				if (newData?.page?.list?.[0]) {
					const d = newData.page.list[0];

					// 기존 필드들 세팅…
					brandDetail.value.brandName = d.brandName;
					brandDetail.value.brandRmks = d.brandRmks;
					// SEO: KB국민카드 프라임+ 전용 브랜드 상세 메타(카드명은 siteProfiles 에서). canonical 은 kbprm 호스트로 고정.
					const kbCard = currentProfile().cardName;
					setPageMeta({
						title: (d.brandName || "제휴 브랜드") + " " + kbCard + " 청구할인" + (d.benefit ? " " + d.benefit + "%" : ""),
						description: "프라임+ 고객은 별도 응모 없이 " + (d.brandName || "제휴 브랜드") + "에서 KB국민카드로 결제 시" + (d.benefit ? " " + d.benefit + "%" : "") + " 청구할인." + (d.brandRmks ? " " + d.brandRmks + "." : "") + " 이용 안내와 가까운 매장 위치를 확인하세요.",
						image: d.logoPath || d.brandPath,
						path: "/HFO_BI_002_KBPRM/" + (d.brandUuid || brandUuid.value),
						origin: "https://kbprm.hivitamin.co.kr",
						type: "article",
					});
					brandDetail.value.brandType = d.brandType;
					brandDetail.value.brandTypeName = d.brandTypeName;
					brandDetail.value.homepageUrl = d.homepageUrl;
					brandDetail.value.benefit = d.benefit;
					brandDetail.value.benefitCard = d.benefitCard;
					brandDetail.value.phone = d.phone;

					// 카드 사용 여부 데이터 추가
					brandDetail.value.nhYn = d.nhYn;
					brandDetail.value.hanaYn = d.hanaYn;
					brandDetail.value.bcYn = d.bcYn;
					brandDetail.value.shYn = d.shYn;
					brandDetail.value.lotteYn = d.lotteYn;
					brandDetail.value.smYn = d.smYn;
					brandDetail.value.kbYn = d.kbYn;
					brandDetail.value.hdYn = d.hdYn;
					// 우리카드 추가
					brandDetail.value.weYn = d.weYn;


					const cfg = getConfig();
					if (cfg.branch && cfg.branch.cardName) {
						brandDetail.value.cardName = cfg.branch.cardName;
					}

					brandDetail.value.brandPath = d.logoPath;
					brandDetail.value.brandDetailView = d.brandDetail;

					// 요약 문단·JSON-LD 의 매장 수. 초기 storeData 는 brandUuid 없이 조회되어 이 브랜드의 매장 수가 아니므로 1건만 따로 조회해 total 을 쓴다.
					brandDetail.value.storeCnt = 0;
					if (d.brandType !== "BRAND_ONLINE") {
						getAxios("/hvm/v1/branch/store", { page: 1, size: 1, brandUuid: d.brandUuid || brandUuid.value })
							.then((res) => { brandDetail.value.storeCnt = Number(res && res.page && res.page.total) || 0; })
							.catch(() => {});
					}

				}
			}
		);

		// 브랜드별 JSON-LD(WebPage·Breadcrumb·Brand·Offer). 브랜드·매장 수가 채워질 때마다 같은 요약 문장으로 갱신한다.
		watch(
			() => [brandDetail.value.brandName, brandDetail.value.benefit, brandDetail.value.storeCnt, cardItems.value.length],
			() => {
				const kbCard = currentProfile().cardName;
				setBrandJsonLd({
					brand: brandDetail.value,
					cards: cardItems.value,
					path: "/HFO_BI_002_KBPRM/" + brandUuid.value,
					listPath: "/HFO_BI_001_KBPRM",
					title: brandDetail.value.brandName ? brandDetail.value.brandName + " " + kbCard + " 청구할인" + (brandDetail.value.benefit ? " " + brandDetail.value.benefit + "%" : "") : "",
				});
			},
		);

		const storeData = useQuery({
			queryKey: [
				"get-branch-store",
				new Date().getTime(),
				popShopReqData.value,
			],
			queryFn: () => getAxios("/hvm/v1/branch/store", popShopReqData.value),
			enabled: false,
		});
		storeData.refetch();

		watch(
			() => storeData.data.value,
			(newData) => {
				if (isSearched.value) {
					return;
				}

				if (newData && newData.page && newData.page.list) {
					// 데이터 업데이트
					popShopList.value = newData.page.list;
					storeList.value = newData.page.list; // this.storeList 대신 storeList.value 사용

					total.value = newData.page.total;
				} else {
					storeList.value = []; // 마찬가지로 storeList.value 사용
				}
			}
		);

		// 페이지 변경 함수도 여기에 정의
		function changePage(newPage) {
			// ... 페이지 변경 로직 ...
			storeData.refetch().then(response => {
				if (response && response.data && response.data.page) {
					storeList.value = response.data.page.list; // 데이터 업데이트
				}
			});
		}

		// 페이지 이탈 시 처리하는 훅 추가
		onBeforeRouteLeave((to) => {
			// HFO_BI_001로 이동하는 경우가 아니면 저장된 카테고리 정보 삭제
			if (to.name !== 'HFO_BI_001' && !to.path.includes('/HFO_BI_001')) {
				console.log("BI_001 외 다른 페이지로 이동: 카테고리 선택 상태 초기화");
				sessionStorage.removeItem('selectedCategoryTab');
				sessionStorage.removeItem('selectedServiceType');
			}
			// 이동 허용
		});

		return {
			brandData,
			brandDetail,
			popShopList,
			popShopReqData,
			storeData,
			currentPage,
			pageSize,
			total,
			isSearched,
			brandDetailView,
			storeList,
			nikeFullSortedList,
			nikeStoreOrder,
			changePage,
			isMobile, // 수정된 isMobile 반환
			isViewportMobile,
			isIndividualCardDomain,
			cardItems,
			cardRows,
			getModalCardStyle,
		};
	},
	computed: {
		isAllCardStatusN() {
			const cardStatusKeys = ['hanaYn', 'bcYn', 'shYn', 'kbYn', 'nhYn', 'lotteYn', 'smYn', 'hdYn', 'weYn'];
			return cardStatusKeys.every((key) => String(this.brandDetail?.[key] || '').trim().toUpperCase() === 'N');
		},
		totalPages() {
			return Math.ceil(this.total / this.pageSize);
		},
		displayedPages() {
			const totalPages = this.totalPages;
			const current = this.currentPage;
			const delta = 2; // 현재 페이지 양쪽에 표시할 페이지 수

			let start = Math.max(1, current - delta);
			let end = Math.min(totalPages, current + delta);

			// 표시 페이지 개수 보정
			if (end - start < 4 && totalPages > 5) {
				if (current <= 3) {
					end = Math.min(5, totalPages);
				} else if (current >= totalPages - 2) {
					start = Math.max(1, totalPages - 4);
				}
			}

			// 페이지 번호 배열 생성
			const pages = [];
			for (let i = start; i <= end; i++) {
				pages.push(i);
			}
			return pages;
		},
		isMobileView() {
			// 팝업 모드 강제 감지 추가
			const hasPopupContainer = typeof window !== 'undefined' &&
				document.querySelector('.brand_popup_container');
			return this.isPopup || hasPopupContainer || this.isMobile;
		},
		// 추가: 템플릿에서 사용할 수 있는 computed 속성
		isPopupMode() {
			// 다중 감지 방식으로 팝업 모드 확인
			const hasPopupContainer = typeof window !== 'undefined' &&
				document.querySelector('.brand_popup_container');
			return this.isPopup || hasPopupContainer;
		},
		// 브랜드 상세보기 안전한 HTML 처리 추가
		safeBrandDetailView() {
			let html = this.brandDetail.brandDetailView || '';
			// 1. href="" 또는 href=''인 a 태그 전체 제거
			html = html.replace(/<a\s+[^>]*href=(["'])\s*\1[^>]*>(.*?)<\/a>/gi, '$2');
			// 2. href 속성만 비어있는 경우도 제거
			html = html.replace(/<a\s+href=(["'])\s*\1[^>]*>(.*?)<\/a>/gi, '$2');
			// 3. (선택) href="#"로 남은 a 태그는 그대로 두고, 정상 url만 남김
			return html;
		},
	},
	methods: {
		onPageChange(newPage) {
			// 유효성 검사
			if (newPage < 1 || newPage > this.totalPages) return;

			// 상태 초기화
			this.selectedStoreIndex = -1;

			// 페이지 번호 업데이트
			this.currentPage = newPage;

			// Nike 검색인 경우 캐시된 데이터로 페이징 처리
			if (this.storeSearchParams.name && this.storeSearchParams.name.includes('나이키') && this.nikeFullSortedList.length > 0) {
				const startIndex = (newPage - 1) * this.pageSize;
				const paginatedList = this.nikeFullSortedList.slice(startIndex, startIndex + this.pageSize);
				this.storeList = paginatedList;
				return;
			}

			// 검색 파라미터를 통해 직접 데이터를 가져오는 경우
			if (this.isSearched) {
				this.fetchStores();
			}
			// Vue Query를 사용하여 데이터를 가져오는 경우
			else {
				// 페이지 정보 업데이트
				this.popShopReqData.page = newPage;

				// API 호출 전 리스트 초기화 (중요)
				this.popShopList = [];

				// 데이터 새로 가져오기
				this.storeData.refetch().then(response => {
					if (response && response.data && response.data.page) {
						// storeList 직접 업데이트
						this.storeList = response.data.page.list;
					}
				});
			}
		},
		makeBrandImageUrl(imagePath) {
			return imagePath
				? process.env.VUE_APP_IMAGE_BASE_URL + "images/" + imagePath
				: DEFAULT_NO_IMAGE;
		},
		// 매장 검색 기능
		async searchStores() {
			// 검색 버튼 클릭 시 실행
			console.log("검색 버튼 클릭 - 현재 검색어:", this.storeSearchParams.name);

			// 검색 상태 설정
			this.isSearched = true;
			this.currentPage = 1;
			this.selectedStoreIndex = -1;

			// 이미 로딩 중인 경우 이전 요청 취소 효과
			this.isLoading.search = false;

			// 검색 실행
			await this.fetchStores();
		},

		// 지역 데이터 초기화 (컴포넌트 마운트 시 호출)
		async initRegionData() {
			await this.fetchRegions();
		},

		// 시도 목록 불러오기
		async fetchRegions() {
			try {
				this.isLoading.regions = true;
				// 지역검색 비활성화: /sido 호출 주석 처리
				// const response = await getAxios("/hvm/v1/branch/sido", {});
				this.regions = [];
			} catch (error) {
				console.error("지역 데이터 로드 실패:", error);
				this.regions = [];
			} finally {
				this.isLoading.regions = false;
			}
		},

		// 구군 목록 불러오기 - API 기반으로 수정
		async fetchSubRegions(sido) {
			if (!sido) {
				this.subRegions = [];
				return;
			}

			try {
				this.isLoading.subRegions = true;
				// 지역검색 비활성화: /gugun 호출 주석 처리
				// const response = await getAxios("/hvm/v1/branch/gugun", { sido: sido });
				this.subRegions = [];
			} catch (error) {
				console.error("구/군 데이터 로드 실패:", error);
				this.subRegions = [];
			} finally {
				this.isLoading.subRegions = false;
			}
		},

		// 기본 구군 데이터 설정 (API 실패 시)
		setDefaultSubRegions(sido) {
			if (sido === "서울") {
				this.subRegions = ["강남구", "강동구", "강북구", "강서구", "관악구", "광진구", "구로구", "금천구", "노원구", "도봉구", "동대문구", "동작구", "마포구", "서대문구", "서초구", "성동구", "성북구", "송파구", "양천구", "영등포구", "용산구", "은평구", "종로구", "중구", "중랑구"];
			} else if (sido === "경기") {
				this.subRegions = ["가평군", "고양시", "과천시", "광명시", "광주시", "구리시", "군포시", "김포시", "남양주시", "동두천시", "부천시", "성남시", "수원시", "시흥시", "안산시", "안성시", "안양시", "양주시", "양평군", "여주시", "연천군", "오산시", "용인시", "의왕시", "의정부시", "이천시", "파주시", "평택시", "포천시", "하남시", "화성시"];
			} else {
				this.subRegions = [];
			}
		},

		// 지역 선택 시 하위 지역 목록 업데이트 - API 기반으로 수정
		async onRegionChange() {
			this.storeSearchParams.gugun = "";
			await this.fetchSubRegions(this.storeSearchParams.sido);
		},

		// 매장 데이터 가져오기
		async fetchStores() {
			// 중복 호출 방지 (이미 로딩 중인 경우 무시)
			if (this.isLoading.search && this.storeList.length > 0) {
				console.log("이미 검색 중이고 결과가 있습니다. 중복 요청 무시");
				return;
			}

			console.log("매장 검색 시작:", new Date().toISOString(), "검색어:", this.storeSearchParams.name);

			try {
				// 검색 시작 전에 목록 초기화 및 로딩 상태 설정
				this.storeList = [];
				this.selectedStoreIndex = -1;
				this.isLoading.search = true;

				// 검색 파라미터 구성
				let params = {
					page: this.currentPage,
					size: this.pageSize
				};

				// Nike 검색 시 전체 데이터 조회 (페이징 없음)
				if (this.storeSearchParams.name && this.storeSearchParams.name.includes('나이키')) {
					params.page = 1;
					params.size = 999; // 전체 데이터 조회
				}

				// 키워드 검색 - name으로 변경
				if (this.storeSearchParams.name) {
					params.name = this.storeSearchParams.name;
				}

				// 브랜드 고정 검색
				const fixedBrandUuid = this.storeSearchParams.brandUuid
					|| this.$route?.params?.brandUuid
					|| this.brandUuid
					|| sessionStorage.getItem("brandUuid");
				if (fixedBrandUuid) {
					params.brandUuid = fixedBrandUuid;
				}

				// 지역 검색 - sido, gugun으로 변경
				if (this.storeSearchParams.sido) {
					params.sido = this.storeSearchParams.sido;
					if (this.storeSearchParams.gugun) {
						params.gugun = this.storeSearchParams.gugun;
					}
				}

				// 위치 정보가 있는 경우 추가 (선택적)
				if (this.storeSearchParams.longitude && this.storeSearchParams.latitude) {
					params.longitude = this.storeSearchParams.longitude;
					params.latitude = this.storeSearchParams.latitude;
				}

				// API 호출 유지
				const response = await getAxios("/hvm/v1/branch/store", params);

				if (response && response.page) {
					let storeData = response.page.list;

					// Nike 검색인 경우 정렬 및 캐싱
					if (this.storeSearchParams.name && this.storeSearchParams.name.includes('나이키')) {
						storeData.sort((a, b) => {
							const indexA = this.nikeStoreOrder.indexOf(a.storeName);
							const indexB = this.nikeStoreOrder.indexOf(b.storeName);

							if (indexA !== -1 && indexB !== -1) return indexA - indexB;
							if (indexA !== -1) return -1;
							if (indexB !== -1) return 1;

							// 나머지는 가나다순
							const nameA = a.storeName || '';
							const nameB = b.storeName || '';
							return nameA.localeCompare(nameB, 'ko-KR', { sensitivity: 'base' });
						});

						// 전체 정렬된 목록 캐싱
						this.nikeFullSortedList = storeData;

						// 현재 페이지에 해당하는 데이터만 표시
						const startIndex = (this.currentPage - 1) * this.pageSize;
						const paginatedList = storeData.slice(startIndex, startIndex + this.pageSize);
						this.storeList = paginatedList;
						this.total = storeData.length;
					} else {
						this.storeList = storeData;
						this.total = response.page.total;
						this.nikeFullSortedList = []; // Nike 아닐 경우 캐시 초기화
					}
				} else {
					this.storeList = [];
					this.total = 0;
					this.nikeFullSortedList = [];
				}
			} catch (error) {
				console.error("매장 데이터 로드 실패:", error);
				this.storeList = [];
				this.total = 0;
				this.nikeFullSortedList = [];
			} finally {
				this.isLoading.search = false;
				// 검색 결과가 표시되었음을 표시
				this.isSearched = true;
			}
		},
		// 매장 지도 토글
		toggleStoreMap(index) {
			// 이미 선택된 매장을 다시 클릭하면 닫기
			if (this.selectedStoreIndex === index) {
				this.selectedStoreIndex = -1;
			} else {
				// 선택한 매장의 좌표 유효성 확인
				const store = this.storeList[index];

				// 위도와 경도가 없거나 유효하지 않은 경우 alert 표시
				if (!store.latitude || !store.longitude ||
					store.latitude === '0' || store.longitude === '0' ||
					isNaN(parseFloat(store.latitude)) || isNaN(parseFloat(store.longitude))) {

					// alert 메시지 표시
					alert('해당 매장의 위치 정보가 없습니다.');
					return; // 함수 종료
				}

				// 좌표가 유효한 경우 지도 표시 진행
				// 1. 모든 맵 로딩 및 준비 상태 초기화
				this.mapLoadedMap = {};
				this.mapReadyMap = {};

				// 2. 현재 열린 맵을 모두 닫기
				this.selectedStoreIndex = -1;

				// 3. 일정 시간 후에 새 맵 열기 (지연 시간 늘림)
				setTimeout(() => {
					// 선택된 매장 인덱스 업데이트하여 맵 표시
					this.selectedStoreIndex = index;
					console.log("지도 토글 - 선택된 매장:", index, "모바일:", this.isMobile);

					// DOM 업데이트를 위한 지연 시간 늘리기
					setTimeout(() => {
						// 지도 컨테이너 확인
						const mapContainerParent = document.querySelector(`.shop_result_list li:nth-child(${index + 1}) .shop_map_area`);
						console.log("지도 컨테이너 부모:", mapContainerParent ? '찾음' : '찾지 못함');

						if (mapContainerParent) {
							// 컨테이너 스타일 강제 적용
							mapContainerParent.style.minHeight = '300px';
							mapContainerParent.style.width = '100%';
							mapContainerParent.style.display = 'block';

							// 강제 리플로우 유발
							void mapContainerParent.offsetHeight;
							console.log("지도 컨테이너 부모 크기:", mapContainerParent.offsetWidth, mapContainerParent.offsetHeight);

							// 모바일에서는 더 긴 지연 시간 사용
							const delay = this.isMobile ? 300 : 50;

							// 지연 후 mapReady 상태 true로 변경
							setTimeout(() => {
								this.mapReadyMap = { ...this.mapReadyMap, [index]: true };
								console.log(`mapReadyMap[${index}]을 true로 설정`);

								// 리사이즈 이벤트 발생시켜 지도 크기 재계산 촉진
								window.dispatchEvent(new Event('resize'));
							}, delay);

							// 스크롤을 맵 위치로 조정
							setTimeout(() => {
								const infoArea = document.querySelector(`.shop_info_area.open`);
								if (infoArea) {
									infoArea.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
								}
							}, delay + 100);
						} else {
							console.warn(`지도 컨테이너 부모를 찾을 수 없음 (인덱스: ${index})`);
						}
					}, 200); // DOM 업데이트 대기 시간 늘림
				}, 150); // 초기 지연 시간 늘림
			}
		},

		// 맵 로드 완료 이벤트 처리
		onMapLoaded(index) {
			// 단일 맵 로딩 상태만 관리
			this.mapLoadedMap = { ...this.mapLoadedMap, [index]: true };
			console.log(`onMapLoaded 호출됨, mapLoadedMap[${index}]:`, this.mapLoadedMap[index]);
		},

		// 지도 오류 처리 메서드
		handleMapError(index) {
			console.error(`지도 로드 오류 발생 (인덱스: ${index})`);
			// 오류 발생 시 재시도 로직
			setTimeout(() => {
				this.mapReadyMap = { ...this.mapReadyMap, [index]: false };
				setTimeout(() => {
					this.mapReadyMap = { ...this.mapReadyMap, [index]: true };
					window.dispatchEvent(new Event('resize'));
				}, 500);
			}, 200);
		},

		// 카드 이미지 URL 생성 함수
		getCardImageUrl(cardCode) {

			// 방법 1: require를 사용하여 로컬 assets에 접근
			return require(`@/assets/images/icon/card-images/card_${cardCode}.png`);

		},

		// 매장찾기 팝업 열기 함수 수정
		openShopSearchPopup() {
			// 호출 순서 변경: 모든 데이터 설정을 먼저 완료한 후 팝업 표시

			// 스토어 목록 초기화
			this.storeList = [];
			this.total = 0;

			// 명칭검색은 사용자 입력값으로 사용
			this.storeSearchParams.name = "";

			// 브랜드 UUID는 현재 상세 브랜드 기준으로 고정
			this.storeSearchParams.brandUuid = this.$route?.params?.brandUuid || this.brandUuid || sessionStorage.getItem("brandUuid") || "";

			// 지역 데이터가 없는 경우 로드
			if (this.regions.length === 0) {
				this.initRegionData();
			}

			// 팝업 열기 (watch 트리거)
			this.searchShop = true;

			// 직접 검색 실행 (watch에서 중복 실행 방지를 위해 searchStores 사용)
			this.$nextTick(() => {
				console.log("매장 검색 실행 (팝업 열기 - searchStores 호출)", this.storeSearchParams.name);
				// searchStores 함수 호출 (페이지 초기화와 검색 로직 통합)
				this.searchStores();

				// 입력 필드에 포커스 설정
				const searchInput = document.querySelector('.search_shop_input .search2');
				if (searchInput) {
					searchInput.focus();
				}
			});
		},
		// 검색 결과 및 관련 상태 초기화 메서드
		resetAndCloseShopSearchPopup() {
			// 진행 중인 검색이 있으면 취소하고 싶지만 axios 요청을 중단하는 건 복잡하므로 상태만 초기화
			this.isLoading.search = false;

			// 나머지 상태 초기화
			this.storeList = [];
			this.total = 0;
			this.currentPage = 1;
			this.isSearched = false;
			this.selectedStoreIndex = -1; // 선택된 매장 인덱스도 초기화

			// 검색 파라미터 초기화
			this.storeSearchParams.sido = "";
			this.storeSearchParams.gugun = "";
			this.storeSearchParams.name = "";
			this.storeSearchParams.brandUuid = this.$route?.params?.brandUuid || this.brandUuid || sessionStorage.getItem("brandUuid") || "";

			// 팝업 닫기
			this.searchShop = false;
		},

		// 브랜드 목록 페이지로 이동하는 메서드 추가
		navigateToBrandList(tabIndex) {
			// 선택한 탭 인덱스를 세션 스토리지에 저장
			sessionStorage.setItem("selectedCategoryTab", tabIndex);

			// 실제 사용 중인 서비스 타입 코드로 수정
			const serviceTypeCodes = [
				"", // 전체
				"SERVICE_SHOPPING", // 쇼핑/생활
				"SERVICE_DINNER", // 외식/레스토랑
				"SERVICE_BAKE", // 커피/제빵
				"SERVICE_BEAUTY", // 패션/뷰티
				"SERVICE_BOOK", // 도서/교육
				"SERVICE_CULTURE", // 문화/헬스
				"SERVICE_TRIP", // 여행/숙박/교통
				"SERVICE_KIDS" // 유아/체험
			];

			if (tabIndex >= 0 && tabIndex < serviceTypeCodes.length) {
				sessionStorage.setItem("selectedServiceType", serviceTypeCodes[tabIndex]);
			} else {
				sessionStorage.removeItem("selectedServiceType");
			}

			// 브랜드 목록 페이지로 이동
			this.$router.push('/HFO_BI_001_KBPRM');
		},
		goBackToList() {
			// 목록보기로 돌아갈 때는 기존 세션 상태를 유지
			// 추가적인 상태 저장이나 초기화 없이 단순히 페이지 이동만 수행
			console.log("목록보기로 돌아가기 - 기존 세션 상태 유지");
			this.$router.push('/HFO_BI_001_KBPRM');
		},
		// 홈페이지 새창으로 열기 (새로 추가)
		openHomepage(url) {
			if (!url || url.trim() === '') {
				alert('홈페이지 정보가 없습니다.');
				return;
			}

			let validUrl = url.trim();

			// http:// 또는 https://가 없으면 https:// 추가
			if (!validUrl.startsWith('http://') && !validUrl.startsWith('https://')) {
				validUrl = `http://${validUrl}`;
			}

			console.log('홈페이지 새창 열기:', validUrl);

			try {
				// 새창으로 열기
				window.open(validUrl, '_blank', 'noopener,noreferrer');
			} catch (error) {
				console.error('홈페이지 새창 열기 실패:', error);
				alert('홈페이지를 열 수 없습니다.');
			}
		},
	}, watch: {
		searchShop(newVal) {
			// 팝업이 열릴 때만 작업
			if (newVal) {
				// 이미 isLoading.search가 true인 경우 (openShopSearchPopup에서 직접 호출 예정)
				if (this.isLoading.search) {
					console.log("검색 진행 중이므로 watch에서 중복 호출 방지");
					return; // 아무 것도 하지 않음 (openShopSearchPopup에서 처리)
				}

				// 만약 isLoading.search가 false인 경우에도 검색을 시작하지 않음
				// 지역 데이터만 필요한 경우 로드
				if (this.regions.length === 0) {
					this.initRegionData();
				}
			} else {
				this.resetAndCloseShopSearchPopup();
			}
		}
	},
	mounted() {
		this.initRegionData();

		// 팝업 컨테이너 감지를 위한 추가 체크
		this.$nextTick(() => {
			const checkPopupMode = () => {
				// DOM이 준비되지 않은 경우 체크
				if (typeof document === 'undefined' || !document.body) {
					console.warn('Document or document.body not available');
					return;
				}

				const popupContainer = document.querySelector('.brand_popup_container');
				if (popupContainer) {
					console.log('BI_002: 팝업 모드 감지됨 - 모바일 스타일 강제 적용');
					// 강제로 모바일 클래스 추가 - null 체크 추가
					if (this.$el && this.$el.classList) {
						this.$el.classList.add('force-mobile-mode');
					}
					// document.body에도 클래스 추가 (null 체크 포함)
					if (document.body && document.body.classList) {
						document.body.classList.add('popup-mobile-mode');
					}
				}
			};
			setTimeout(checkPopupMode, 100);
		});
	}
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/pages/bi_002.scss';

.card-label.is-hivitamin-target {
	color: #111;
	font-weight: 600;
	font-size: calc(1em + 1px);
}

.card-label.is-hivitamin-target .hivitamin-word {
	color: #7a5b00;
}

:deep(.brand_top_menu) {
	background-color: #ffe39a;
}

:deep(.btn_notice_unified),
:deep(.btn_notice_unified::before),
:deep(.bill_discount),
:deep(.bill_discount .title_bill),
:deep(.bill_discount .discount_percent),
:deep(.bill_discount .discount_percent strong) {
	color: #7a5b00;
}

:deep(.bill_discount) {
	border-color: #7a5b00;
}

:deep(.brand_detail_area .detail_info_area .bill_discount) {
	border-color: #7a5b00 !important;
}

:deep(.brand_detail_area .detail_info_area .bill_discount .title_bill),
:deep(.brand_detail_area .detail_info_area .bill_discount .discount_percent),
:deep(.brand_detail_area .detail_info_area .bill_discount .discount_percent strong) {
	color: #7a5b00 !important;
}

:deep(.brand_top_menu .brand_menu_list li > a) {
	color: #111 !important;
}

:deep(.brand_top_menu .brand_menu_list li > a > img) {
	width: 24px !important;
	height: 24px !important;
	min-width: 24px !important;
	max-width: 24px !important;
	min-height: 24px !important;
	max-height: 24px !important;
	object-fit: contain !important;
	mix-blend-mode: multiply;
}

:deep(.btn_notice_unified::before) {
	border-color: #7a5b00;
}

:deep(.btn_shop_area .btn_type2),
:deep(.btn_shop_area .btn_type2) {
	background-color: #ffe39a;
	color: #7a5b00;
	box-shadow: 0 4px 10px rgba(122, 91, 0, 0.2);
}

:deep(.btn_write_area .btn_list) {
	background-color: #ffe39a !important;
	border: 0 !important;
	color: #7a5b00 !important;
	box-shadow: 0 4px 10px rgba(122, 91, 0, 0.2) !important;
}

:deep(.btn_write_area .btn_list::before) {
	content: '☰';
	width: auto;
	height: auto;
	background: none !important;
	color: #111;
	font-size: 24px;
	font-weight: 400;
	line-height: 1;
}

:deep(.brand_detail_area .btn_shop_area .btn_type2::before) {
	filter: brightness(0);
}

/* KBPRM 매장찾기 모달 컬러 오버라이드 */
:deep(.layer_popup.search_shop) {
	border: 2px solid #ffe39a !important;
}

:deep(.layer_popup.search_shop .title_search_shop) {
	color: #7a5b00 !important;
	border-bottom: 1px solid #ffe39a !important;
}

:deep(.layer_popup.search_shop .title_search_shop span) {
	color: #7a5b00 !important;
}

:deep(.layer_popup.search_shop .search_shop_area) {
	background-color: #fff7e6 !important;
}

:deep(.layer_popup.search_shop .btn_search button) {
	background-color: #ffe39a !important;
	color: #7a5b00 !important;
	border: 1px solid #e7cc79 !important;
	box-shadow: 0 4px 10px rgba(122, 91, 0, 0.2) !important;
}

:deep(.layer_popup.search_shop .btn_search button:hover) {
	background-color: #f4d77f !important;
	color: #6b4f00 !important;
}

:deep(.layer_bg .layer_popup.search_shop) {
	border-color: #ffe39a !important;
}

:deep(.layer_popup.search_shop .discout_percent) {
	color: #7a5b00 !important;
}

:deep(.layer_popup.search_shop .paging_num button.active),
:deep(.layer_popup.search_shop .paging_area2 .prev),
:deep(.layer_popup.search_shop .paging_area2 .next) {
	color: #7a5b00 !important;
}

.bill_discount.special-discount {
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	overflow: hidden;
	border-color: #ffe39a;
	background: linear-gradient(180deg, #fffdf4 0%, #fff7d8 100%);
	box-shadow: 0 4px 10px rgba(122, 91, 0, 0.12);
}

.bill_discount.special-discount .special_discount_text {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: calc(100% - 10px);
	height: calc(100% - 10px);
	margin: 0;
	padding: 0;
	border-radius: 4px;
	border: 1px solid rgba(255, 227, 154, 0.8);
	background: linear-gradient(180deg, #fffefa 0%, #fff9e6 100%);
	color: #7a5b00;
	font-weight: 700;
	font-size: 13px !important;
	letter-spacing: 0.02em;
	line-height: 1.05;
	transform: translateY(-2px);
}

.bill_discount.special-discount .special_discount_text span {
	display: block;
	width: 100%;
	text-align: center;
	padding: 0 2px;
	font-size: inherit !important;
}

.bill_discount.special-discount .special_discount_text span+span {
	margin-top: 1px;
	padding-top: 0;
	border-top: none !important;
	text-decoration: none !important;
	width: 100%;
}

@media (max-width: 1023px) {
	.bill_discount.special-discount {
		box-shadow: 0 3px 8px rgba(122, 91, 0, 0.1);
	}
}
</style>